import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { PermissionService } from '@lyceo/shared/permissions/data-access';

export function hasPermissionGuard(
  permission: string | string[],
  redirectUrl: string[],
): CanActivateFn {
  return () => {
    const router: Router = inject(Router);
    const permissionService: PermissionService = inject(PermissionService);

    return permissionService.hasPermission(permission).pipe(
      map((hasPermission) => {
        if (hasPermission) {
          return true;
        }

        return router.createUrlTree(redirectUrl);
      }),
    );
  };
}
